import { useI18n } from "@/contexts/I18nContext";
import { MinusOutlined, CloseOutlined } from "@ant-design/icons";
import { Flex, Popover, Modal, Button, Space } from "antd";
import { closeSession, switchLanguages } from "@/services";
import { useCallback, useRef, useState } from "react";
import { getAgentFromScript } from "@/utils";
import UserSatisfactionSurveyModal from "../UserSatisfactionSurveyModal";
import { useWebSocket } from "../WebSocketProvider";
import { ComponentsTypeEnum } from "@/constants";
import styles from "./index.module.scss";

//头部右侧内容
const RenderExtraContent = ({
  agentData,
  dialogueMessages,
  onClose,
  cardRef,
  setIsCloseSession,
  closeSSE,
  hadleModalHidden, //控制弹窗的可见性
  getAgentInitList, // 获取智能体初始化数据的函数
}: any) => {
  const satisfactionSurveyRef = useRef<any>(null);
  const [popoverOpen, setPopoverOpen] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const { disconnect } = useWebSocket();
  const { locale, setLocale, formatMessage } = useI18n();

  //获取语言列表内容
  const getLangContent = useCallback(() => {
    const { setting } = agentData;

    return (
      <div className={styles.languageContent}>
        {setting?.lang_list?.map((item: any) => {
          return (
            <div
              key={item.code}
              className={`${styles.languageText} ${
                locale === item.code ? styles.actived : ""
              }`}
              id="change_language_button"
              data-track-element
              onClick={async () => {
                const res: any = await switchLanguages({
                  agent: getAgentFromScript(),
                  lang: item?.code,
                });
                if (res.code === 0) {
                  setLocale(item.code);
                  setPopoverOpen(false);
                  //重新初始化对话
                  getAgentInitList();
                }
              }}
            >
              {item.description}
            </div>
          );
        })}
      </div>
    );
  }, [agentData, getAgentInitList, locale, setLocale]);

  //关闭弹窗
  const closeModal = async () => {
    setLoading(true);
    try {
      const res: any = await closeSession({
        agent: getAgentFromScript(),
      });
      if (res.code === 0) {
        closeSSE(); //关闭SSE请求
        onClose(); //关闭聊天窗口
        setIsCloseSession(true);
        //关闭ws连接
        disconnect();
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Flex align="center" style={{ gap: 24 }}>
        <Popover
          content={getLangContent()}
          trigger="click"
          placement="bottom"
          open={popoverOpen}
          onOpenChange={(open: boolean) => {
            setPopoverOpen(open);
          }}
          getPopupContainer={() => cardRef?.current || document.body}
        >
          <Button type="link" style={{ padding: 0 }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="none"
            >
              <path
                fill="#9b9999"
                fillRule="evenodd"
                d="M4.931 2.554a6.3 6.3 0 0 0-2.377 2.377 23 23 0 0 1 1.983-.394q.153-.998.394-1.983m1.734-.661a21 21 0 0 0-.579 2.46 23 23 0 0 1 3.828 0 21 21 0 0 0-.579-2.46 6.3 6.3 0 0 0-2.67 0M4.353 6.086a21 21 0 0 0-2.46.579 6.3 6.3 0 0 0 0 2.67q1.217.363 2.46.579a23 23 0 0 1 0-3.828m1.525 4.036c-.14-1.411-.14-2.833 0-4.244 1.411-.14 2.833-.14 4.244 0 .14 1.411.14 2.833 0 4.244-1.411.14-2.833.14-4.244 0m-1.341 1.341a23 23 0 0 1-1.983-.394 6.3 6.3 0 0 0 2.377 2.377 23 23 0 0 1-.394-1.983m2.128 2.644a21 21 0 0 1-.579-2.46c1.274.107 2.554.107 3.828 0q-.216 1.243-.579 2.46a6.3 6.3 0 0 1-2.67 0m7.442-7.442a21 21 0 0 0-2.46-.579 23 23 0 0 1 0 3.828q1.243-.216 2.46-.579a6.3 6.3 0 0 0 0-2.67m-2.644 4.798a23 23 0 0 1-.394 1.983 6.3 6.3 0 0 0 2.377-2.377q-.985.241-1.983.394m-.394-8.909q.241.985.394 1.983a23 23 0 0 1 1.983.394 6.3 6.3 0 0 0-2.377-2.377M.25 8a7.75 7.75 0 1 1 15.5 0A7.75 7.75 0 0 1 .25 8"
                clipRule="evenodd"
              ></path>
            </svg>
          </Button>
        </Popover>
        <MinusOutlined
          id="hidden_to_agent_button"
          data-track-element
          onClick={() => {
            // onClose();
            hadleModalHidden(true); //设置modal隐藏
            setIsCloseSession(false);
          }}
        />
        <CloseOutlined
          onClick={() => {
            setOpen(true);
          }}
        />
      </Flex>
      {/* 关闭弹窗 */}
      <Modal
        open={open}
        width={"60%"}
        wrapClassName={styles.customModalWrap}
        getContainer={() => cardRef?.current || document.body}
        onCancel={() => setOpen(false)}
        footer={
          <Space>
            <Button
              id="cancel_to_agent_button"
              data-track-element
              onClick={() => setOpen(false)}
            >
              {formatMessage("cancelText")}
            </Button>
            <Button
              type="primary"
              loading={loading}
              onClick={() => {
                setOpen(false);
                const isServiceEnd = dialogueMessages?.some(
                  (item: { component: string }) =>
                    item?.component &&
                    item?.component === ComponentsTypeEnum.GRADE,
                );
                if (dialogueMessages.length > 1 && !isServiceEnd) {
                  satisfactionSurveyRef.current.setVisit(true);
                } else {
                  closeModal();
                }
              }}
            >
              {formatMessage("okText")}
            </Button>
          </Space>
        }
      >
        {formatMessage("closeContentText")}
      </Modal>
      {/* 满意度调查弹窗 */}
      <UserSatisfactionSurveyModal
        ref={satisfactionSurveyRef}
        cardRef={cardRef}
        loading={loading}
        closeModal={closeModal}
        satisfaction={agentData.satisfaction}
      />
    </>
  );
};

export default RenderExtraContent;
